export interface IGlobalSettings {
  fuelConsumption: Number
  sellingPrice: Number
  repairingPrice: Number
  depreciationVehicle: Number
  depreciationCharge: Number
  oilRefillKm: Number
  oilRefillMonth: Number
  depreciationRemooc: Number
  sellingPriceRemooc: Number
  markup: Number
}
const initGlobalSettings = {
  fuelConsumption: 0,
  sellingPrice: 0,
  repairingPrice: 0,
  depreciationVehicle: 0,
  depreciationCharge: 0,
  oilRefillKm: 0,
  oilRefillMonth: 0,
  depreciationRemooc: 0,
  sellingPriceRemooc: 0,
  markup: 0
}

export default {
  initGlobalSettings
}
